import React, { useState } from 'react';
import './index.css';
import { Dropdown } from 'react-bootstrap';

const CustomToggle = React.forwardRef(({ isToggled, label, value, height, width, onClick }, ref) => {
    const toggleClass = isToggled ? "toggledActive" : "toggled";
    return (
        <div className={toggleClass} ref={ref} onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
            style={{
                alignItems: 'center', justifyContent: 'space-between', display: "flex",
                borderRadius: "4px",
                height: height ? height : "56px",
                border: "1px solid #CED1D9", width: width
            }}>
            <label className="label14" style={styles.formLabel}>{value || label}</label>
            <div className="dropdownTriangle" style={{ marginRight: 8 }} />
        </div>
    );
});

const CustomToggledDisabled = ({ height: height, width, label }) => {
    return (
        <div
            className="inputValue divRow inputValueDisabled"
            style={{ alignItems: 'center', justifyContent: 'space-between', height: height, width: width }}>
            <label className="label14" style={styles.formLabel}>{label}</label>
            <div className="dropdownTriangle" style={{ marginRight: 8 }} />
        </div>
    );
}

export const CustomDropdown = ({ label = "", value = "", items = [], height, width = 200, disabled = false, onChange = null }) => {
    // Fix: Move useState before any conditional returns
    const [isToggled, setIsToggled] = useState(false);

    if (disabled) {
        return <CustomToggledDisabled height={height} width={width} label={label} />
    }

    return (
        <Dropdown onToggle={e => setIsToggled(e)} onSelect={(e) => onChange(e)}>
            <Dropdown.Toggle
                as={CustomToggle}
                isToggled={isToggled}
                label={label}
                value={value}
                width={width}
                height={height}
                id="dropdown-custom-components" />
            <Dropdown.Menu
                className="dropdownConfig"
                style={{ width: width }}
                align="start" // Added for Bootstrap 5 compatibility
            >
                {items.map((item, indx) => (
                    <Dropdown.Item key={item + indx} eventKey={indx}>{item}</Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}

const styles = {
    formLabel: {
        color: '#6d758e',
        padding: 0,
        marginLeft: 16
    },
};